<template lang="pug">
  .container-winners
    CartelImage.image-ren(ref="cartel")
    SelectWinner(:code="code", :data-concurse="dataConcurse", :winner-data="winnerData", ref="winnerSurfboard",:id-table="idTable")
    //BubblesAvatars(:data-concurse="dataConcurse")
    .sea(ref="sea")
    .sand#area-sand
    .man-standing(:class="{ 'scene-1' : !selectingWinner, 'scene-2' : selectingWinner }",ref="man")
    .ball(ref="ball")
    .content-surfboards(ref="surfboards")
      .surfboard-content(v-for="(surfboard, index) in surfboards", :style="{ width: surfboard.width + 'px', height: surfboard.height + 'px', left: surfboard.x + 'px', top: '-' + surfboard.y + 'px' }")
        .surfboard(:style="{ transform: surfboard.rotate, backgroundImage: surfboard.image }",:id="'surf-'+index")
          .ticket.surfboard-ticket
        .sand-table
        .shadow-table
    #stars-c.content-stars(ref="stars")
      .surfboard-content(v-if="", v-for="(star, index) in stars", :style="{ width: star.width + 'px', height: star.height + 'px', left: star.x + 'px', top: star.y + 'px' }")
        .surfboard(:style="{ transform: star.rotate, backgroundImage: star.image }")
    .waves(ref="waves")
    .tickets(ref="tickets")
      .ticket.empty(ref="ticket-empty")
      .ticket(ref="ticket")
        .results(v-if="$root.winner.id != null")
          span.name {{ $root.winner.nombre }}
          span.mat(@click="hideTickets()") {{ $root.winner.matricula }}
          span.date-mat {{ getMatriculaDate }}
          span.date-ren {{ getRenovacionDate }}
          span.id {{ $root.winner.identificacion }}
          span.phone(v-if="$root.winner.ssiConfecamara.telcom1") {{ $root.winner.ssiConfecamara.telcom2 ? $root.winner.ssiConfecamara.telcom1 + ', ' : $root.winner.ssiConfecamara.telcom1 }}{{ $root.winner.ssiConfecamara.telcom3 ? $root.winner.ssiConfecamara.telcom2 + ', ' : $root.winner.ssiConfecamara.telcom2 }}{{ $root.winner.ssiConfecamara.telcom3 }}
          span.email {{ $root.winner.ssiConfecamara.munComName }}
          span.address {{ $root.winner.ssiConfecamara.dircom }}
          span.con-text {{ getConcurseText.text }}
          span.dest-text {{ getConcurseText.dest }}
          img.dest(:src="getConcurseText.image")
</template>

<script>

import { TweenMax, TimelineMax, Power3 } from 'gsap'
import CartelImage from './PageConcurso2020/CartelImage'
import SelectWinner from './Winners2020/SelectWinner'

export default {
  name: 'base-winners-ren',
  props: {
    code: Object,
    dataConcurse: Array,
    winnerData: Object,
    countSurfboards: {
      type: Number,
      required: false
    }
  },
  components: {
    CartelImage,
    SelectWinner,
    //BubblesAvatars
  },
  computed: {
    getConcurseText(){
      if(this.$root.winner.id != null){
        switch(this.$root.winner.concurso_code){
          case 'REN_GAN_ENERO_2020':
          return {text:'Enero 2020',dest:'San Andrés',image:'/images/destinos-01.png'};
          case 'REN_GAN_FEBRERO_2020':
          return {text:'Febrero 2020',dest:'Cartagena',image:'/images/destinos-02.png'};
          case 'REN_GAN_MARZO_2020':
          return {text:'Marzo 2020',dest:'Cartagena',image:'/images/destinos-02.png'};
          default:
          return {text:'',dest:'Cartagena',image:'/images/destinos-02.png'};
        }
      }
      return {text:'',dest:'Cartagena',image:'/images/destinos-02.png'};
    },
    getMatriculaDate(){
      if (this.$root.winner.id != null) {
        return moment(this.$root.winner.ssiConfecamara.fechamatricula).format("YYYY-MM-DD");
      }
      return null
    },
    getRenovacionDate(){
      if (this.$root.winner.id != null) {
        return moment(this.$root.winner.ssiConfecamara.fecharenovacion).format("YYYY-MM-DD");
      }
    }
  },
  data() {
    return {
      surfboards: [],
      stars: [],
      idTable: 0,
      selectingWinner: false
    }
  },
  watch: {
    selectingWinner(v) {
      let vm = this
      if (v) {
        vm.shutBall()
         window.switchSurf = setInterval(() => {
          _.forEach(vm.surfboards, (s) => {
            let id = vm.getRandom(1, 4);
            s.id = id
            s.image = `url(/images/beach/Surfboard${id}.svg)`
          })
        }, 100)
      } else {
        clearInterval(window.switchSurf)
      }
    }
  },
  methods: {
    showTickets(hasPlay = true){
      const { tickets } = this.$refs

      TweenMax.to(tickets, 0, {
        x: '50%',
        y: '-35%',
        rotation: -70
      })

      TweenMax.to(tickets, hasPlay?3:1, {
        x: '-50%',
        y: '-43%',
        rotation: 0,
        delay: hasPlay?13:.5
      })

      TweenMax.to(tickets.children[0], hasPlay?3:1, {
        y: -34,
        rotation: 5,
        delay: hasPlay?13:.5
      })

      TweenMax.to(tickets.children[1], hasPlay?2:.7, {
        y: -144,
        rotation: -5,
        delay: hasPlay?13.4:.5
      })
    },
    hideTickets(){
      const { tickets } = this.$refs

      TweenMax.to(tickets, 3, {
        x: '50%',
        y: '-35%',
        rotation: -70
      })

      TweenMax.to(tickets.children[0], 3, {
        y: 0,
        rotation: 0
      })

      TweenMax.to(tickets.children[1], 2, {
        y: 0,
        rotation: 0
      })
    },
    shutBall() {
      let vm = this
      const { ball, winnerSurfboard, sea, man, waves, surfboards, stars, tickets } = this.$refs

      TweenMax.fromTo(winnerSurfboard.$el, 1, {
        x: '0%',
        opacity: 1
      },
      {
        x: '120%',
        opacity: 0
      })

      TweenMax.to(ball, 0, {
        left: 174,
        y: 0,
      })

      TweenMax.to(sea, 0, {
        left: 0,
      })

      TweenMax.to(sea, 11, {
        left: -10000,
        ease: Power3.easeOut,
        delay: 1
      })

      TweenMax.to(surfboards, 0, {
        left: 0,
      })

      TweenMax.to(surfboards, 11, {
        left: -10000,
        ease: Power3.easeOut,
        delay: 1
      })

      TweenMax.to(stars, 0, {
        left: 0,
      })

      TweenMax.to(stars, 11, {
        left: -10000,
        ease: Power3.easeOut,
        delay: 1
      })

      TweenMax.to(waves, 0, {
        left: 0,
      })

      TweenMax.to(waves, 11, {
        left: -10000,
        ease: Power3.easeOut,
        delay: 1
      })

      TweenMax.to(man, 0, {
        left: 70,
      })

      TweenMax.to(man, 11, {
        left: -5000,
        ease: Power3.easeOut,
        delay: 1
      })

      TweenMax.to(ball, 4, {
        left: window.innerWidth - 330,
        y: -450,
        ease: Power3.easeOut,
        delay: 1
      })

      TweenMax.to(ball, 6, {
        left: window.innerWidth/2 + 200,
        delay: 4
      })
      let firstDelay = 2.5
      let alt = true
      let currentY = -350
      let lastY = -350
      let currentDuration = 1.3
      for (var i = 0; i < 12; i++) {
        if(alt){
          alt=false
          lastY = currentY
          currentY = 100
        }else{
          alt = true
          currentY = lastY*0.5
        }
        TweenMax.to(ball, currentDuration, {
          y: currentY,
          ease: !alt?Power3.easeIn:Power3.easeOut,
          delay: firstDelay
        })
        currentDuration-=0.1
        firstDelay+=currentDuration
      }
      setTimeout(function() {
        let id = vm.getRandom(1, 4);
        vm.idTable = vm.surfboards[44].id = id
        vm.surfboards[44].image =  `url(/images/beach/Surfboard${id}.svg)`
      },5000)
      TweenMax.fromTo(winnerSurfboard.$el, .7, {
        x: '-120%',
        opacity: 0
      },
      {
        x: '0%',
        opacity: 1
      }).delay(11)
      setTimeout(function() {
        document.getElementById('surf-44').style.filter ='drop-shadow(2px -1px 10px rgba(0,0,0,0.4))'
      },11000);
      TweenMax.to(document.getElementById('surf-44'), .7,
      {
        y: '-20%',
        scale: 1.4,
        rotation: 2
      }).delay(11)
      vm.showTickets()

    },
    createSurfboards() {
      let vm = this
      for (var i = 0; i < 100; i++) {
        let id = vm.getRandom(1, 4);
        vm.surfboards.push({
          width: vm.getRandom(65, 90),
          height: vm.getRandom(230, 270),
          //x: (i + 1) * vm.getRandom(230, 250),
          x: (i+1) * 249,
          y: vm.getRandom(),
          rotate: `rotate(${vm.getRandom(-6, 4)}deg)`,
          id: id,
          image: `url(/images/beach/Surfboard${id}.svg)`,
        })
        if (vm.surfboards[i].height > 240) {
          vm.surfboards[i].y += 30
        }
      }
    },
    createStars() {
      let vm = this
      for (var i = 0; i < 100; i++) {
        vm.stars.push({
          width: vm.getRandom(50, 130),
          height: vm.getRandom(25, 120),
          x: (i + 1) * vm.getRandom(190, 210),
          y: vm.getRandom(20,180),
          rotate: `rotate(${vm.getRandom(-10, 8)}deg)`,
          image: `url(/images/beach/SeaStar${vm.getRandom(1, 2)}.svg)`,
        })
        if (vm.stars[i].height > 240) {
          vm.stars[i].y += 30
        }
      }
    },
    getRandom(min = 3, max = 45) {
      return Math.floor(Math.random() * (max - min + 1) + min)
    },
  },
  mounted() {
    let vm = this
    this.createSurfboards()
    this.createStars()
    const { winnerSurfboard, cartel } = this.$refs

    let palms = document.getElementsByClassName('content-palms')[0]

    TweenMax.to(winnerSurfboard.$el, 0, {
      x: '-75%',
      delay: 0
    })

    TweenMax.to(palms, 0, {
      y: -450,
      delay: 0
    })

    TweenMax.to(cartel.$el, 0, {
      y: -250,
      opacity: 0,
      delay: 0
    })

    TweenMax.to(winnerSurfboard.$el, 3, {
      x: '0%',
      delay: 1
    })

    TweenMax.to(palms, 3, {
      y: -50,
      delay: 1
    })

    TweenMax.to(cartel.$el, 1, {
      y: 0,
      opacity: 1,
      delay: 1
    })
  }
}
</script>

<style lang="sass">
  .results
    position: absolute
    width: 100%
    height: 100%
    .dest-text
      position: absolute
      font-family: cursive;
      left: 1282px
      top: 660px
      font-size: 22px
      color: white
    img.dest
      position: absolute
      left: 1000px
      top: 890px
      width: 160px
      height: 160px
    .name, .mat, .date-mat, .date-ren, .id, .phone, .email, .address, .con-text
      position: absolute
      font-weight: bold
      text-transform: uppercase
    .name
      font-size: 50px
      top: 730px
      left: calc(50% + -80px)
      transform: translateX(-50%)
      max-width: 840px
      padding: 0 20px
      text-align: center
      line-height: 45px
    .date-ren
      top: 635px
      left: 465px
      font-size: 25px
    .con-text
      left: 68px
      top: 780px
      color: rgba(0, 0, 0, 0.2)
      -webkit-transform: rotate(-90deg)
      transform: rotate(-90deg)
      font-size: 55px
      text-align: center
      width: 420px
    .address
      top: 635px
      left: 775px
      line-height: 21px
      font-size: 25px
      width: 400px
      overflow: hidden
      text-align: center
      max-width: 450px
    .mat
      top: 955px
      left: calc(50% - 112px)
      transform: translateX(-50%)
      font-size: 60px
    .id, .date-mat, .phone, .email
      right: 148px
      font-size: 25px
      width: 200px
      overflow: hidden
    .id
      top: 737px
    .date-mat
      top: 807px
    .phone
      top: 874px
      line-height: 23px
    .email
      top: 962px
  .tickets
    position: fixed
    width: 1600px
    height: 1600px
    top: 50%
    left: 50%
    transform: translate(100%, -50%) rotate(-70deg)
    z-index: 100
  .ticket
    position: absolute
    width: inherit
    height: inherit
    background-repeat: no-repeat
    background-image: url(/images/beach/ticket.svg)
    background-size: contain
    &.surfboard-ticket
      background-position: center 
      width: 100%
      height: 90px
      top: 10px
      left: 50%
      transform: translateX(-50%)
    &.empty
      background-image: url(/images/beach/ticket-empty.svg)
  .ball
    position: fixed
    background-image: url(/images/beach/people/Ball.svg)
    width: 100px
    height: 100px
    background-repeat: no-repeat
    bottom: 205px
    left: 174px
    z-index: 2
    &.anim-ball
      animation: jumpBall 1s linear infinite alternate
  .man-standing
    position: fixed
    //transition: 10s ease-out
    width: 200px
    height: 300px
    bottom: 220px
    left: 70px
    z-index: 1
    background-repeat: no-repeat
    background-position: top
    &.scene-1
      background-image: url(/images/beach/people/StandingMan.svg?1)
      background-size: 200px 1930px
      animation: animMan 10000ms steps(6) infinite
    &.scene-2
      background-image: url(/images/beach/people/StandingMan3.svg)
  .surfboard
    position: absolute
    width: 100%
    height: 100%
    background: round
    background-position: bottom
    background-repeat: no-repeat
  .content-surfboards,.content-stars,#drawable
    position: fixed
    width: 20000px
    height: 300px
    bottom: 0
    left: 0
  #drawable
    z-index: 3
    bottom: 0px
  .content-surfboards
    z-index: 2
    left: 110px
  .content-stars
    z-index: 1
  .sand-table
    position: absolute
    background-image: url(/images/beach/SandTable.svg)
    width: 100%
    height: 20px
    bottom: -10px
    left: 0
    background-repeat: no-repeat
  .shadow-table
    background-image: url(/images/beach/ShadowTable.svg)
    position: absolute
    width: 100%
    height: 20px
    bottom: -8px
    left: 29px
    background-repeat: no-repeat
    z-index: -1
    mix-blend-mode: multiply
  .surfboard-content
    transition: 10s ease-out
    position: absolute
    width: 65px
    height: 230px
    top: -10px
    left: 300px
  .waves
    position: fixed
    width: 20000px
    height: 70px
    background-size: contain
    background-repeat: repeat
    background-image: url(/images/beach/Waves.svg)
    bottom: 260px
    left: -20px
    animation: moveWaves 2s ease infinite alternate
    &:after
      content: ''
      position: absolute
      width: 100%
      height: 100%
      background-image: url(/images/beach/WaveFoam.svg)
      top: -55px
  .sea
    position: fixed
    width: 20000px
    height: 200px
    bottom: 240px
    left: 0
    //transition: 10s ease-out
    background: url(/images/beach/Sea.svg)
    z-index: -1
    background-repeat-y: no-repeat
    background-repeat-x: repeat
    background-size: contain
  .sand
    position: fixed
    width: 100%
    height: 300px
    bottom: 0
    left: 0
    background: url(/images/beach/SandSea.svg)
    z-index: -2
  canvas
    position: fixed
    top: 0
    left: 0
    z-index: -1
  .container-winners
    margin-top: 40px
  .image-ren
    position: relative
    width: 300px !important
  @keyframes animMan
    from
      background-position: 0px 0px
    to
      background-position: 0px -1960px
  @keyframes ball
    from
      transform: rotate(0deg)
    to
      transform: rotate(6deg)
  @keyframes moveWaves
    from
      transform: translateY(-10px)
      opacity: 1
    to
      transform: translateY(0px)
      opacity: 0
</style>



// WEBPACK FOOTER //
// resources/js/components/BaseWinnersRen.vue